import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import layersEmptyState from 'images/layers-empty-state.svg';
import { useProjectManager } from 'providers/ProjectManagerProvider';
import { useUserInfo } from 'providers/UserInfoProvider';
import React from 'react';

type Props = {
  onCreateLayerClick: () => void;
};

const NoLayersContent: React.FC<Props> = ({ onCreateLayerClick }) => {
  const projectManager = useProjectManager();
  const userInfo = useUserInfo();
  const { permissions } = projectManager.getSelectedProject();
  const role = userInfo.getCurrentUserRole();
  const isAdmin = role === 'admin';
  const { translate } = useTranslator(['mapView']);

  const description = isAdmin
    ? `${translate('mapView:noLayersContent.toGetViewingDrawings')}`
    : `${translate('mapView:noLayersContent.mustCreateLayer')}`;

  return (
    <div className="px7 column items-center">
      <img
        src={layersEmptyState}
        alt="Layers Empty State Illustration"
        className="pt7 pb4"
      />
      <h1 className="font-size-7 mb2">
        {translate('mapView:noLayersContent.noLayers')}
      </h1>
      <p className="font-size-5 center mt0 mb7">{description}</p>
      {permissions.createMapLayer && (
        <Button
          size="large"
          variant="primary"
          onClick={onCreateLayerClick}
          id="map-create-layer-btn"
        >
          {translate('mapView:noLayersContent.createLayer')}
        </Button>
      )}
    </div>
  );
};

export default NoLayersContent;
